module.exports = __webpack_public_path__ + "front/img/b13.51912ef1.png";